import { render, staticRenderFns } from "./FamousFormWeb.vue?vue&type=template&id=db6fe510&"
import script from "./FamousFormWeb.vue?vue&type=script&lang=js&"
export * from "./FamousFormWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports